const ROUTES = {
  APP: '/app',
  OUTPUT: '/app/output',
  VOLUME: '/app/volume',
  IMPACT: '/app/impact'
};

export default ROUTES;
